import GapsAuditFindingsTable from './GapsAuditFindingsTable';

export default GapsAuditFindingsTable;
